import { AppError } from "../common/app-error";

export class BadInput extends AppError {}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/nostra-mufit-info-prod/workspace/src/app/pages/common/bad-input.ts